import { z } from "zod";
export const ConnectionBotAccessInput = z.object({ connectionId: z.string().min(1).max(120) });
export const ConnectionBotAccessUpdate = ConnectionBotAccessInput.extend({
  allBots: z.boolean(),
  botIds: z.array(z.string().min(1).max(120)).max(400),
}).strict();
export const ConnectionBotAccess = z.object({
  connectionId: z.string(),
  allBots: z.boolean(),
  botIds: z.array(z.string()),
  bots: z.array(z.object({ id: z.string(), name: z.string() })),
});
